// extracted by mini-css-extract-plugin
module.exports =  {"phone":"_2787e5dfdf--phone--Fv2IK"};